export default __webpack_public_path__ + "static/media/logo-colored.b1b23436.png";